<template>
  <b-container fluid class="mt-5">
    <b-modal
      centered
      size="lg"
      id="modal-leaks"
      hide-footer
      :title="`Cadastro de ${origin === 'leak' ? 'Leak' : 'Arquivo'} `"
    >
      <b-container tag="form">
        <b-row v-if="origin == 'leak'">
          <b-col cols="6">
            <input
              type="text"
              class="form-control mt-15"
              placeholder="Nome"
              required
              v-model="form.name"
            />
          </b-col>
          <b-col cols="6">
            <input
              type="date"
              class="form-control mt-15"
              placeholder="Data"
              required
              v-model="form.date"
            />
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col cols="12">
            <app-select
              :data="{
                options: typesChannel,
                valueDefault: 'Selecione o leak',
                required: true,
              }"
              v-model="typeChannel"
            />
          </b-col>
          <b-col cols="12" class="my-3">
            <app-upload />
          </b-col>
            <b-col cols=12>
            <hr />
            <h5 class="f-default f-bold">Review</h5>
            <p class="f-default mb-0">Nome do arquivo: <strong>{{inputFile.fileName ? inputFile.fileName : '---'}}</strong> </p>
          </b-col>
        </b-row>
      

        <b-row>
          <b-col cols="12" class="mt-3 d-flex justify-content-end">
            <b-button
              variant="outline-warning"
              @click="$bvModal.hide('modal-leaks')"
            >
              <i class="fa fa-ban" aria-hidden="true"></i>
              Cancelar</b-button
            >
            <b-button variant="outline-primary" type="submit" class="ml-2">
              <i class="fa fa-plus mr-1" aria-hidden="true"></i>Salvar</b-button
            >
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-row>
      <b-col cols="12">
        <h4 class="f-default">Gerenciar Leaks</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" md="4">
        <app-info-card
          :data="{
            title: 'Quantidade de Leaks',
            content: 0,
          }"
        />
      </b-col>
      <b-col cols="12" md="4">
        <app-info-card
          :data="{
            title: 'Quantidade de Entradas',
            content: 0,
          }"
        />
      </b-col>
      <b-col cols="12" md="4">
        <b-card class="btns-actions">
          <b-row class="h-100">
            <b-col cols="6">
              <b-button
                class="h-100 w-100"
                variant="outline-secondary"
                @click="
                  origin = 'leak';
                  $bvModal.show('modal-leaks');
                "
              >
                <img
                  src="@/assets/img/svgs/add_2.svg"
                  height="30"
                  class="mb-1"
                />
                <br />
                Vazamentos
              </b-button>
            </b-col>
            <b-col cols="6">
              <b-button
                class="h-100 w-100"
                variant="outline-secondary"
                @click="
                  origin = 'upload';
                  $bvModal.show('modal-leaks');
                "
              >
                <img
                  src="@/assets/img/svgs/add_2.svg"
                  height="30"
                  class="mb-1"
                />
                <br />
                Arquivos
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="py-3">
      <b-col cols="12" md="3" offset="3">
        <b-form-input placeholder="Nome do canal" v-model="search" />
      </b-col>
      <b-col cols="12" md="3">
        <app-select
          :data="{
            options: typesChannel,
            valueDefault: 'Tipo de canal',
            required: true,
          }"
          v-model="typeChannel"
        />
      </b-col>

      <b-col cols="6" md="3" class="d-flex justify-content-center">
        <b-button variant="secondary" class="w-50 mr-1" @click="cleanFn"
          >Limpar</b-button
        >

        <b-button variant="primary" @click="searchFn" class="w-50"
          >Pesquisar</b-button
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <app-acordeon :data="item" />
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import appInfoCard from "@/components/_infoCard";
import appAcordeon from "@/components/lokiDashboard/_accordeon";

export default {
  components: {
    appInfoCard,
    appAcordeon,
  },
  data() {
    return {
      form: {},
      origin: "",
      range: "",
      search: "",
      masks: {
        input: "DD/MM/YYYY",
      },
      item: {
        id: "leaks",
        title: "Leak",
        table: {
          fields: [
            { key: "id", label: "ID" },
            { key: "name", label: "Name" },
            { key: "createdAt", label: "Created" },
            { key: "closedAt", label: "Closed" },
            { key: "status", label: "Status" },
          ],
          items: [],
        },
        isButton: false,
      },
      typesChannel: [],
      typeChannel: "",
      inputFile:{}
    };
  },
  methods: {
    searchFn() {},
    cleanFn() {
      this.search = "";
      this.range = "";
    },
  },
};
</script>
<style lang="scss">
.btns-actions {
  border: none !important;
  height: 101px;
}

#modal-leaks{
  .list-reviews{
    max-height: 350px;
    overflow: auto;
  }
}
</style>